import React from "react";
import Button from "@mui/material/Button";
import {clearAllFiles} from "../../lib/fileHandlers";
import {UPLOADING_STATUS} from "../../constants";


const ClearButton = ({setFiles, setStatus, status, reset, setIsLoadingStarted, setIsUploadButtonDisabled}) => {

    return (
        <Button
            color="primary"
            style={{color: "#db3f3f"}}
            variant="outlined"
            size="large"
            onClick={() => {
                clearAllFiles(setFiles, setStatus, reset)
                setIsLoadingStarted(false)
                setIsUploadButtonDisabled(true)
            }}
            disabled={status === UPLOADING_STATUS.Loading}
        >
            Очистить
        </Button>
    )
};
export {ClearButton};
